module.exports = __webpack_public_path__ + "img/logo.8b7055c2.png";